import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { TrustDeviceRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/JanusService.pb'
import { TrustDeviceResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/JanusService.pb'

export const trustDevice = (request: TrustDeviceRequest, options?: CashRequestOptions) =>
  post<TrustDeviceRequest, TrustDeviceResponse>('/2.0/cash/trust-device', request, { ...options, rejectOnError: true })
